import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold" }, "Откуда", -1)
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold" }, "Куда", -1)
const _hoisted_8 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-lg" }, "10 тонник", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-lg" }, "20 тонник", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "xxl",
    scrollable: "",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.confirmButtonText,
    loading: _ctx.state.is_loading,
    onCancel: _ctx.onCancel,
    onConfirm: _ctx.onConfirm
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_the_select, {
          value: _ctx.state.sender_city,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.sender_city) = $event)),
          placeholder: "Выберите из списка",
          loading: _ctx.cities_state.is_loading,
          disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
          failed: _ctx.cities_state.is_failed,
          options: _ctx.cities_state.list,
          "error-text": "При получении списка городов произошла ошибка",
          "is-invalid": _ctx.state_form$.sender_city.$error,
          "validation-errors": _ctx.state_form$.sender_city.$errors,
          onRefresh: _ctx.loadCities
        }, null, 8, ["value", "loading", "disabled", "failed", "options", "is-invalid", "validation-errors", "onRefresh"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.transit_cities, (city, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `transit-city-${i}`,
            class: "grid grid-cols-1 gap-3"
          }, [
            _createElementVNode("div", _hoisted_3, "Транзит №" + _toDisplayString(i + 1), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_select, {
                class: "w-full",
                value: _ctx.state.transit_cities[i],
                "onUpdate:value": ($event: any) => ((_ctx.state.transit_cities[i]) = $event),
                placeholder: "Выберите из списка",
                loading: _ctx.cities_state.is_loading,
                disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                failed: _ctx.cities_state.is_failed,
                options: _ctx.cities_state.list,
                "error-text": "При получении списка городов произошла ошибка",
                onRefresh: _ctx.loadCities
              }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "failed", "options", "onRefresh"]),
              _createVNode(_component_the_button, {
                class: "red text small",
                onClick: ($event: any) => (_ctx.deleteTransitCity(i))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128)),
        _createVNode(_component_the_button, {
          class: "primary text small",
          onClick: _ctx.addTransitCity
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Добавить город транзит ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _hoisted_7,
        _createVNode(_component_the_select, {
          value: _ctx.state.receiver_city,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.receiver_city) = $event)),
          placeholder: "Выберите из списка",
          loading: _ctx.cities_state.is_loading,
          disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
          failed: _ctx.cities_state.is_failed,
          options: _ctx.cities_state.list,
          "error-text": "При получении списка городов произошла ошибка",
          "is-invalid": _ctx.state_form$.receiver_city.$error,
          "validation-errors": _ctx.state_form$.receiver_city.$errors,
          onRefresh: _ctx.loadCities
        }, null, 8, ["value", "loading", "disabled", "failed", "options", "is-invalid", "validation-errors", "onRefresh"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_the_select, {
            class: "mt-2",
            placeholder: "Тип перевозки",
            searchable: false,
            value: _ctx.state.invoiceType,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.invoiceType) = $event)),
            disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
            options: _ctx.TRANSPORTATION_TYPES,
            "is-invalid": _ctx.state_form$.invoiceType.$error,
            "validation-errors": _ctx.state_form$.invoiceType.$errors
          }, null, 8, ["value", "disabled", "options", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Введите тариф 'Газель'",
            disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
            value: _ctx.state.capacity_1500,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.capacity_1500) = $event)),
            "is-invalid": _ctx.state_form$.capacity_1500.$error,
            "validation-errors": _ctx.state_form$.capacity_1500.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Введите тариф '3 тонник'",
            disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
            value: _ctx.state.capacity_3000,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.capacity_3000) = $event)),
            "is-invalid": _ctx.state_form$.capacity_3000.$error,
            "validation-errors": _ctx.state_form$.capacity_3000.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Введите тариф '5 тонник'",
            disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
            value: _ctx.state.capacity_5000,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.capacity_5000) = $event)),
            "is-invalid": _ctx.state_form$.capacity_5000.$error,
            "validation-errors": _ctx.state_form$.capacity_5000.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
        ]),
        _hoisted_9,
        _createVNode(_component_the_input, {
          placeholder: "Введите тариф '10 тонник'",
          disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
          value: _ctx.state.capacity_10000,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.capacity_10000) = $event)),
          "is-invalid": _ctx.state_form$.capacity_10000.$error,
          "validation-errors": _ctx.state_form$.capacity_10000.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _hoisted_10,
        _createVNode(_component_the_input, {
          placeholder: "Введите тариф '20 тонник'",
          disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
          value: _ctx.state.capacity_20000,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.capacity_20000) = $event)),
          "is-invalid": _ctx.state_form$.capacity_20000.$error,
          "validation-errors": _ctx.state_form$.capacity_20000.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          placeholder: "тг/кг",
          value: _ctx.state.costPerWeight,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.costPerWeight) = $event)),
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.state_form$.costPerWeight.$error,
          "validation-errors": _ctx.state_form$.costPerWeight.$errors
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
      ])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "loading", "onCancel", "onConfirm"]))
}